// extracted by mini-css-extract-plugin
export var footer = "Footer--footer--3SJ3E";
export var footer__company = "Footer--footer__company--v06-L";
export var footer__company__accreditation = "Footer--footer__company__accreditation--T2UDt";
export var footer__company__divider = "Footer--footer__company__divider--iFpmN";
export var footer__icons = "Footer--footer__icons--9D0rc";
export var footer__links = "Footer--footer__links--paeuQ";
export var footer__scrollToTop = "Footer--footer__scrollToTop--+xt2n";
export var footer__social = "Footer--footer__social--WVD6n";
export var tkMyriadProSemiCondensed = "Footer--tk-myriad-pro-semi-condensed--z0aI2";